export default __webpack_public_path__ + "static/media/instagram.25c207a5.png";